import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import JobCard from './JobCard';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        [theme.breakpoints.down('md')]: {
            display: 'block',
        },
    },
    item: {
        flexBasis: '50%',
        padding: theme.spacing(1),
        [theme.breakpoints.down('md')]: {
            flexBasis: '100%',
        },
    },
    link: {
        textDecoration: 'none',
        color: 'inherit',
        display: 'block',
        '&:hover': {
            textDecoration: 'none',
        },
        '&:focus': {
            textDecoration: 'none',
        },
        '&:active': {
            textDecoration: 'none',
        },
        '&:visited': {
            textDecoration: 'none',
        },
    },
    noData: {
        textAlign: 'center',
        padding: theme.spacing(3),
        color: theme.palette.text.secondary,
        fontSize: '1.6rem',
    }
}));

export default function JobList({ jobList, savedJobIds, appliedJobIds }) {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            {
                !jobList || jobList.length === 0
                    ? <Typography className={classes.noData}>データがありません</Typography>
                    : jobList.map(job => {
                        let saved = savedJobIds.includes(job._id);
                        let applied = appliedJobIds.includes(job._id);

                        return (
                            <Box key={job._id} className={classes.item}>
                                <Link className={classes.link} to={`/jobs/${job._id}`}>
                                    <JobCard job={job} saved={saved} applied={applied} />
                                </Link>
                            </Box>
                        )
                    })
            }
        </Box>
    )
}
